// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [5],
		"/calculator": [6],
		"/contact": [7],
		"/embed/bend-points": [8,[2]],
		"/embed/filing-age-couple": [10,[2]],
		"/embed/filing-age": [9,[2]],
		"/embed/indexed-earnings": [11,[2]],
		"/guides": [12,[3]],
		"/guides/100k-income": [13,[3]],
		"/guides/1st-and-2nd-of-month": [14,[3]],
		"/guides/25k-income": [15,[3]],
		"/guides/40k-income": [16,[3]],
		"/guides/60k-income": [17,[3]],
		"/guides/80k-income": [18,[3]],
		"/guides/agency-changes": [19,[3]],
		"/guides/aime": [20,[3]],
		"/guides/child-benefits": [21,[3]],
		"/guides/cola": [22,[3]],
		"/guides/covid-awi-drop": [23,[3]],
		"/guides/delayed-january-bump": [24,[3]],
		"/guides/delayed-retirement-credits": [25,[3]],
		"/guides/divorced-spouse": [26,[3]],
		"/guides/earnings-cap": [27,[3]],
		"/guides/earnings-record-paste": [28,[3]],
		"/guides/earnings-test": [29,[3]],
		"/guides/federal-taxes": [30,[3]],
		"/guides/filing-date-chart": [31,[3]],
		"/guides/government-shutdown": [32,[3]],
		"/guides/indexing-factors": [33,[3]],
		"/guides/inflation": [34,[3]],
		"/guides/integrations": [35,[3]],
		"/guides/international-agreements": [36,[3]],
		"/guides/maximum": [37,[3]],
		"/guides/mortality": [38,[3]],
		"/guides/nra": [39,[3]],
		"/guides/pia": [40,[3]],
		"/guides/privacy": [41,[3]],
		"/guides/projectionlab-review": [42,[3]],
		"/guides/retroactive-survivor-benefits": [43,[3]],
		"/guides/senior-tax-deduction": [44,[3]],
		"/guides/spousal-benefit-filing-date": [45,[3]],
		"/guides/spousal-benefits": [46,[3]],
		"/guides/state-taxes": [47,[3]],
		"/guides/strategy-vs-opensocialsecurity": [48,[3]],
		"/guides/survivor-benefits": [49,[3]],
		"/guides/url-parameters": [50,[3]],
		"/guides/wep": [51,[3]],
		"/guides/will-social-security-run-out": [52,[3]],
		"/guides/work-credits": [53,[3]],
		"/guides/working-past-full-retirement-age": [54,[3]],
		"/strategy": [55]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);